import { createContext } from 'react';
import { RouterContextValue } from './RouterContextValue';

export const RouterContext = createContext<RouterContextValue>(null);
RouterContext.displayName = 'Fusion Routes';
